import React, { JSX } from 'react';
import { Navigate } from 'react-router';
import { useAuth0 } from "@auth0/auth0-react";
import { Spinner } from "react-bootstrap";
import LoadingSpinner from "./LoadingSpinner";

const AuthenticatedRoute = ({ children }: { children: JSX.Element }) => {
    const {isAuthenticated, isLoading} = useAuth0();

    return isLoading ?
        <LoadingSpinner /> :
        !isAuthenticated ?
            <Navigate to="/"/> :
            <>{children}</>
};

export default AuthenticatedRoute;
